module.exports = __webpack_public_path__ + "static/media/barberscape-3.18392144.jpg";